{
  "title": "Spare the Dying",
  "source": "Player's Handbook",
  "levelAndSchool": "Necromancy cantrip",
  "level": 0,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S",
  "duration": "Instantaneous",
  "description": [
    "You touch a living creature that has 0 hit points. The creature becomes stable. This spell has no effect on undead or constructs."
  ],
  "spellLists": ["artificer", "cleric"]
}
